import { EventData, SwipeableProps as ReactSwipeableProps, Swipeable, SwipeableOptions } from 'react-swipeable';

export type SwipeableProps = ReactSwipeableProps & SwipeableOptions;
export type SwipeableEvent = EventData;

const SwipeableComponent = (props: SwipeableProps) => <Swipeable {...props} />;

export default SwipeableComponent;
